'use client';
import dynamic from 'next/dynamic';

const PolicyPDFViewer = dynamic(() => import('@/components/PolicyPDFViewer'), {
  ssr: false,
});

export default function Page() {
  return (
    <PolicyPDFViewer
      fileUrl="https://triotech-website.famapp.co.in/Terms_of_Use.pdf"
      languageSwitch={{
        href: '/terms/hindi/',
        label: 'Want to view this in Hindi? Click here',
      }}
      pageClassName="pdf-viewer-page"
    />
  );
}
